import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { FaHome, FaBoxOpen, FaShoppingCart, FaUsers, FaChartLine, FaCog, FaTrophy, FaImage, FaUserShield } from 'react-icons/fa';

const NavContainer = styled.div`
  background-color: #1e2a38;
  color: white;
  width: 100%;
  padding: 1rem;
  margin-bottom: 2rem;
  border-radius: 8px;
`;

const NavTitle = styled.h3`
  margin: 0 0 1rem 0;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 1.2rem;
`;

const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  
  @media (min-width: 768px) {
    flex-wrap: nowrap;
  }
`;

const NavItem = styled.li`
  margin-bottom: 0.5rem;
  flex: 1 1 auto;
  min-width: 120px;
  
  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  border-radius: 4px;
  transition: all 0.2s;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: white;
  }
  
  &.active {
    background-color: #C41E3A;
    color: white;
  }
  
  svg {
    margin-right: 0.5rem;
  }
`;

const AdminNav = () => {
  return (
    <NavContainer>
      <NavTitle>Admin Navigation</NavTitle>
      <NavList>
        <NavItem>
          <StyledNavLink to="/admin" end>
            <FaHome /> Dashboard
          </StyledNavLink>
        </NavItem>
        <NavItem>
          <StyledNavLink to="/admin/products">
            <FaBoxOpen /> Products
          </StyledNavLink>
        </NavItem>
        <NavItem>
          <StyledNavLink to="/admin/hero">
            <FaImage /> Hero Slides
          </StyledNavLink>
        </NavItem>
        <NavItem>
          <StyledNavLink to="/admin/orders">
            <FaShoppingCart /> Orders
          </StyledNavLink>
        </NavItem>
        <NavItem>
          <StyledNavLink to="/admin/customers">
            <FaUsers /> Customers
          </StyledNavLink>
        </NavItem>
        <NavItem>
          <StyledNavLink to="/admin/user-accounts">
            <FaUserShield /> User Accounts
          </StyledNavLink>
        </NavItem>
        <NavItem>
          <StyledNavLink to="/admin/analytics">
            <FaChartLine /> Analytics
          </StyledNavLink>
        </NavItem>
        <NavItem>
          <StyledNavLink to="/admin/treasure-hunt">
            <FaTrophy /> Treasure Hunt
          </StyledNavLink>
        </NavItem>
        <NavItem>
          <StyledNavLink to="/admin/settings">
            <FaCog /> Settings
          </StyledNavLink>
        </NavItem>
      </NavList>
    </NavContainer>
  );
};

export default AdminNav;
